import classifyTargets from 'stores/sharing/classifyTargets';

/**
 * Does any sharing target (potentially) have slack enabled?
 *
 * Best effort -- we look at the user store for individual users (this may be out of date because of server-side
 * caching). If any of them have slackIds set, return true.
 *
 * We don't know who's in particular teams or departments, so, if any of those are included, returns true.
 *
 * Callers should probably be listening to the stores used here: UserStore and FileUploadSharingDialogFormStore.
 *
 * @return {boolean} true if any of the sharing targets are teams, departments, or users with slackIds.
 */
export default function anyTargetMayHaveSlack(sharingValues, users) {
  const {userIds, teamIds, departmentIds} = classifyTargets(sharingValues);
  const targetUsers = userIds.map(userId => users.get(userId)).filter(user => user);
  return (
    teamIds.length > 0 || departmentIds.length > 0 || !!targetUsers.find(u => u.slackId != null)
  );
}
